import {
  IonGrid,
  IonRow,
} from "@ionic/react";
import UnifiedLayerPanel from "./UnifiedLayerPanel";


const DesktopLayerSelector = ({
  colors,
  setColors,
  imageDimensions,
  file,
  setFile,
  isLoading,
  submitBtn,
  onOpenBitmapDebug,
  crop,
  compact,
  vertical,
  verticalCompact,
  onAddNewClick,
}) => {
  if (verticalCompact) {
    // Ultra-compact vertical layout for sidebar within image
    return (
      <div
        style={{
          width: "100%",
          fontFamily: "Clash Grotesk",
          color: "#202020",
          flex: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <UnifiedLayerPanel
          colors={colors}
          setColors={setColors}
          file={file}
          imageDimensions={imageDimensions}
          showLayerPreviews={false}
          onLayerVisibilityChange={(visibleLayers) => {
            console.log('Layer visibility changed:', visibleLayers);
          }}
          crop={crop}
          verticalCompact={true}
          onAddNewClick={onAddNewClick}
        />
      </div>
    );
  }

  if (compact) {
    // Compact horizontal layout for floating color panel.
    // display:contents lets the individual chips become direct flex items of
    // the parent bar so they wrap together with the Edit/Apply controls.
    return (
      <div
        style={{
          display: "contents",
          fontFamily: "Clash Grotesk",
          color: "#202020",
        }}
      >
        <UnifiedLayerPanel
          colors={colors}
          setColors={setColors}
          file={file}
          imageDimensions={imageDimensions}
          showLayerPreviews={false}
          onLayerVisibilityChange={(visibleLayers) => {
            console.log('Layer visibility changed:', visibleLayers);
          }}
          crop={crop}
          compact={true}
          onAddNewClick={onAddNewClick}
        />
      </div>
    );
  }

  if (vertical) {
    // Vertical sidebar layout for detected colors
    return (
      <div
        style={{
          width: "100%",
          fontFamily: "Clash Grotesk",
          color: "#202020",
          flex: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <UnifiedLayerPanel
          colors={colors}
          setColors={setColors}
          file={file}
          imageDimensions={imageDimensions}
          showLayerPreviews={false}
          onLayerVisibilityChange={(visibleLayers) => {
            console.log('Layer visibility changed:', visibleLayers);
          }}
          crop={crop}
          vertical={true}
          onAddNewClick={onAddNewClick}
        />
      </div>
    );
  }

  // Original vertical layout
  return (
    <>

      <div
        style={{
          width: "100%",
          height: "100%",
          margin: "0px",
          padding: "0px",
          fontFamily: "Clash Grotesk",
          color: "#202020",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <div
          className="layer-selector-scroll"
          style={{
            padding: "8px 6px 16px 6px",
            background: "rgba(0, 0, 0, 0.04)",
            borderRadius: "8px",
            fontSize: "10px",
            fontWeight: 500,
            margin: "8px 6px 16px 6px",
            border: "1px solid #E3E3E3",
            flex: 1,
            overflowY: "auto",
            minHeight: 0,
          }}
        >
          <UnifiedLayerPanel
            colors={colors}
            setColors={setColors}
            file={file}
            imageDimensions={imageDimensions}
            showLayerPreviews={true}
            onLayerVisibilityChange={(visibleLayers) => {
              console.log('Layer visibility changed:', visibleLayers);
            }}
            crop={crop}
            onAddNewClick={onAddNewClick}
          />
        </div>
      </div>
    </>
  );
};

export default DesktopLayerSelector;
